/**
 * The work lines of a DRIVER-realm partner (D621): one person may carry passengers by car, by moto, deliver food or deliver
 * parcels on different days. A work line is WHAT the partner is set up for — never a dispatch decision (that stays the ONE
 * service-eligibility decision, `evaluateServiceEligibility`, which also weighs documents, onboarding and suspensions).
 *
 * - `RIDE_<CLASS>`: a dispatch-registry row of the market whose physical vehicle is ACTIVE and whose LATEST inspection in the
 *   market PASSED, lists that registry category and is still in force — the class is the one the operator verified.
 * - `FOOD` / `SEND`: the partner's own courier opt-in (Food mode, Send acceptance).
 *
 * Neutral: a vehicle class is the `@vello/service-categories` VEHICLE_CLASSES vocabulary; a category is market data.
 */
import { INSPECTION_VEHICLE_CLASSES } from './review.js';
export const RIDE_WORK_LINES = ['RIDE_CAR', 'RIDE_MOTO', 'RIDE_VAN', 'RIDE_UTILITY', 'RIDE_TRUCK', 'RIDE_BIKE'];
export const COURIER_WORK_LINES = ['FOOD', 'SEND'];
/** Display and filter order: the ride lines (car first), then the courier lines. */
export const WORK_LINES = [...RIDE_WORK_LINES, ...COURIER_WORK_LINES];
export const isWorkLine = (v) => typeof v === 'string' && WORK_LINES.includes(v);
export const isInspectionVehicleClass = (v) => typeof v === 'string' && INSPECTION_VEHICLE_CLASSES.includes(v);
/** The ride work line of a verified vehicle class. */
export const rideWorkLineOf = (vehicleClass) => `RIDE_${vehicleClass.toUpperCase()}`;
/** The vehicle class a ride work line stands for (`undefined` for a courier line). */
export function vehicleClassOfRideLine(line) {
    if (!line.startsWith('RIDE_'))
        return undefined;
    const cls = line.slice('RIDE_'.length).toLowerCase();
    return isInspectionVehicleClass(cls) ? cls : undefined;
}
/** De-duplicated, unknown codes dropped, in {@link WORK_LINES} order. */
export function orderWorkLines(lines) {
    const set = new Set(lines);
    return WORK_LINES.filter((l) => set.has(l));
}
//# sourceMappingURL=work-lines.js.map